const dropdown = document.getElementById("dropdown");
const selected = document.getElementById("selected");
const options = document.getElementById("options");

selected.addEventListener("click", () => {
  options.classList.toggle("show");
});

options.querySelectorAll(".option").forEach((option) => {
  option.addEventListener("click", () => {
    selected.innerHTML = option.innerHTML; // Copy image + title
    options.classList.remove("show");

    // 👉 Redirect to product URL
    const productUrl = option.getAttribute("data-url");
    if (productUrl) {
      window.location.href = productUrl;
    }
  });
});

window.addEventListener("click", (e) => {
  if (!dropdown.contains(e.target)) {
    options.classList.remove("show");
  }
});
